<template>
<v-main class="pa-3 pb-4">

  <TabelaFuncionarios
   v-bind:lista-funcionarios-ativos="listaFuncionariosAtivos"
   v-bind:lista-funcionarios-desativos="listaFuncionariosDesativos"
   v-bind:descricao-funcionario="'Apoios'"
   v-bind:tipo-funcionario="'1'"
   v-on:alterar-dados-funcionario="alterarDadosFuncionario"
   v-on:ativar-funcionario="ativarFuncionario"
   v-on:desativar-funcionario="desativarFuncionario"
  >
  </TabelaFuncionarios>

 <v-layout style="height: 90px; position: relative" right bottom >
    <v-btn  id="mybutton" top-of="footer" right fab dark color="teal darken-4" @click=""  :to="{path:'/cadastrarApoioUnidade'}">
          <v-icon  dark>add</v-icon>
    </v-btn>
  </v-layout>
</v-main>

</template>

<script>
import Cookies from 'js-cookie'
import TabelaFuncionarios from './../../../assets/components/TabelaFuncionarios'
import administradorUnidadeService from '../../../services/administradorUnidade.service'

export default {
  name: 'listaApoio',
  components: {
    TabelaFuncionarios
  },
  data () {
    return {
      page: 1,
      tipo: 7,
      listaFuncionariosAtivos: [],
      listaFuncionariosDesativos: [],
      listaFuncionarios: [],
      user: null
    }
  },

  mounted () {
    console.log('em mounted adm...')
    this.user = this.$store.getters.usuario
    this.retornarFuncionarios() // apoios são considerador como funcionários..
  },
  methods: {

    alterarDadosFuncionario (item) {
      console.log('alter')
      this.$router.push({ name: 'alterarDadosApoio', params: { item: item } })
    },

    ativarFuncionario (item) {
      console.log('ativ')
      if (confirm('Deseja ativar esse painel?')) {
        // this.items.splice(index, 1)
        const index = this.listaFuncionariosDesativos.indexOf(item)
        administradorUnidadeService.administradorUnidade.ativarFuncionario
        (item.username)
          .then(rsp => {
            console.log('rsp oi:')
            if (rsp.data == true) {
              this.listaFuncionariosDesativos.splice(index, 1)
              this.listaFuncionariosAtivos.push(item)
            }
          })
          .catch(err => {
            // handle your error here
            console.log(err)
          })
      }
    },

    desativarFuncionario (item) {
      console.log('desat')
      if (confirm('Deseja desativar esse painel?')) {
        const index = this.listaFuncionariosAtivos.indexOf(item)
        administradorUnidadeService.administradorUnidade.desativarFuncionario
        (item.username)
          .then(rsp => {
            console.log('rsp oi:')
            if (rsp.data == true) {
              this.listaFuncionariosAtivos.splice(index, 1)
              this.listaFuncionariosDesativos.push(item)
            }
          })
          .catch(err => {
          // handle your error here
            console.log(err)
          })
      }
    },

    retornarFuncionarios () {
      console.log('em retornar funcionarios atendente...')
      administradorUnidadeService.administradorUnidade
        .retornarFuncionarios(this.tipo)
        .then(rsp => {
          console.log('rsp oi:')
          this.listaFuncionarios = rsp.data
          console.log(rsp.data)
          this.listaFuncionarios.forEach(funcionario => {
            if (funcionario.ativo) {
              this.listaFuncionariosAtivos.push(funcionario)
            } else { this.listaFuncionariosDesativos.push(funcionario) }
          })

          // console.log(this.listaChamadas);
          // this.servicoTeste = rsp.data
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    },
    alterarDadosApoio (item) {
      console.log('em alterar dados..')
      this.$router.push({ name: 'alterarDadosApoio', params: { item: item } })
    }
  },
  created () {
    console.log('created...')
  }
}
</script>

<style  scoped>
  .md-card {
    width: 320px;
    margin: 4px;
    display: inline-block;
    vertical-align: top;
  }

  .feedback {
  background-color : #31B0D5;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  border-color: #46b8da;
}

#mybutton {
  position: fixed;
  bottom: 20px;
  right: 10px;
}
</style>
